<app-carrier-form
  [carrierType]="carrierType"
  [pending]="pending$ | async"
  [drawer]="drawer"
  [formLoaded]="formFieldsLoaded"
  [errorMessage]="errorMessage$ | async"
  [carrierFields]="carrierFieldsConfig"
  (submitForm)="submitForm($event)"
  [timeZone]="ianaTimeZone"
  [operationMode]="'create'"
  [isOnTrialPlan]="isOnTrialPlan">
</app-carrier-form>
<ng-template #trackStarComponent></ng-template>
